import { init } from '@sentry/react';
init({
  dsn: 'https://ecf11affc83ebf9286b59a30ba73d834@o292676.ingest.us.sentry.io/4509451659706368',
  enabled: import.meta.env.PROD,
});
